import { Pipe, PipeTransform } from '@angular/core';
import { UtilsService } from '../services/utils.service';

@Pipe({
  name: 'document',
  standalone: false
})
export class DocumentPipe implements PipeTransform {
  constructor(private utilsService: UtilsService) {
  }

  transform(value: string, type = 'CNPJ'): string {
    if (!value) {
      return value;
    }

    const onlyNumbers = value?.replace(/\D/g, '');
    if (['CNPJ', 'CAEPF', 'CPF'].includes(type)) {
      return this.utilsService.maskCpfCnpj(onlyNumbers);
    }
    return value;
  }
}
